import { Geography, GeoTreeNode, allRegions, FilterOption } from '../types/types';

/* eslint-disable arrow-body-style */
export const formikSubmitDisabled = (formik: any) => {
  const { isValid, isSubmitting } = formik;
  return (!isValid || isSubmitting);
};
const oneMil = 1000000.0;
export const dollarFormatInstruction = '(in dollars)';
export const tbd = 'Missing required info';
export const optionalInfo = 'Missing info (optional)';

export const convertDollarsToMillions = (amountInDollars: number) => {
  const inMils = amountInDollars / oneMil;
  return Math.round(inMils * 100 + Number.EPSILON) / 100;
};
export const convertMillionsToDollars = (amountInMillions: number) => amountInMillions * oneMil;
export const formatDollarsAsMillions = (amountInDollars: number, noUnits: boolean = false) => {
  const inMils = convertDollarsToMillions(amountInDollars);
  return noUnits ? `${inMils}` : `$${inMils}M`;
};

export const wholeDollarsOmitTrailingZeros = (amountInMillions: number) => {
  return Number(Number(amountInMillions).toFixed(0));
};

export const filterOptionsAreSame = (options1: FilterOption[], options2: FilterOption[]) => {
  if (options1.length === options2.length) {
    const sorted1 = options1.sort((a, b) => ((a.key <= b.key) ? -1 : 1));
    const sorted2 = options2.sort((a, b) => ((a.key <= b.key) ? -1 : 1));
    let same = true;

    options1.forEach((option1, idx) => {
      const option2 = options2[idx];
      same = same && option1.query === option2.query && option1.key === option2.key;
    });

    return same;
  }
  return false;
};
